import React, {Component, PropTypes} from 'react';
import Firebase from 'firebase';
import cx from 'classnames';
import ReactSelect from 'react-select';
import SearchInput, {createFilter} from 'react-search-input';
import _ from 'lodash';

export default class Questions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      lastSearchTerm: ''
    };
  }

  getInitialProps() {
    return {
      questions: []
    };
  }

  searchUpdated(term) {

    console.log(this, this.state);

    const currentSearchTerm = this.state.searchTerm;
    if (term.length > 3) {
      this.setState({searchTerm: term, page: 0, lastSearchTerm: currentSearchTerm});
    } else {
      this.setState({searchTerm: '', page: 0, lastSearchTerm: currentSearchTerm});
    }
  }

  handleDelete(question) {
    console.log('Delete ', question);
    let questions = this.state.questions;

    let r = confirm("Are you sure? This will delete everything related to this question.");
    if (r == true) {
      console.info('Confirmed deletion');

      const db = Firebase.database();
      db.ref("questions/" + question).remove().then(snapshot => {
        // success
        _.remove(questions, {
          id: question
        });
        this.setState({
          deleting: question,
          deleteMessage: 'Please wait...'
        });
        this.cleanQuestions(question);


      }, error => {
        // The Promise was rejected.
        this.setState({
          deleting: null,
          deleteMessage: ''
        });
      });

    }
    else {
      console.info('Cancelled');
      this.setState({
        deleting: null
      });
    }
  }

  cleanQuestions(qsId) {

    let questions = this.state.questions;

    const db = Firebase.database();
    db.ref("questions").once("value", questions => {
      // console.info("questions", questions.val());
      let qs = questions.val();
      // retrieve quiz details
      db.ref("quizzes").once("value", quizzes => {
        let qz = quizzes.val();
        for (let quiz in qz) {

          // loop through quiz questions and check if one has been deleted
          for (let question in qz[quiz].questions) {
            if (!qs[question]) {
              console.warn('quiz question missing: ', question);
              let q = {};
              q[question] = false;
              db.ref("quizzes/" + quiz + "/questions/" + question).remove();
            }
          }

          this.setState({
            deleteMessage: 'Checking user data...',
            deleting: null,
          });

        }

      });

      this.setState({
        deleteMessage: 'Checking user data...'
      });

      // retrieve user details (is this required?)
      db.ref("users").once("value", users => {
        let users1 = users.val();
        let n = 0;

        this.setState({
          deleteMessage: 'Please wait... Checking user data...'
        });
        for (let usr in users1) {
          n++;
          // console.info(n, 'user quizzes: ', users1[usr].quizzes);
          let qz = users1[usr].quizzes;

          // loop through quiz questions and check if one has been deleted
          for (let quiz in qz) {
            for (let question in qz[quiz].questions) {
              if (!qs[question]) {
                console.warn('user question missing: ', question);
                let q = {};
                q[question] = false;
                db.ref("users/" + usr + "/quizzes/" + quiz + "/questions/" + question).remove();
              }
            }
          }

          this.setState({
            deleting: null,
            deleteMessage: ''
          });

        }

      });

    });

  }

  /*
   *   RENDER METHODS
   */

  render() {

    let DOMAIN = this.props.domain;
    let searchTerm = this.state.searchTerm;
    let questions = this.state.questions;
    if (searchTerm) {
      const KEYS_TO_FILTERS = ['question', 'question.quizzes'];
      questions = questions.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
      // let maxNumToShow = opponents.length > 12 ? 12 : opponents.length;
      // questions = questions.slice(0, maxNumToShow);
      // console.log('searchTerm', searchTerm, this.props.users.length, opponents)
    }

    _.orderBy(questions, 'quiz');

    let questionsList = questions.map((question, index) => {

      return (
        <li style={{listStyle: 'none', marginLeft: '0'}} key={'question' + index}>
          <button style={{
            marginRight: '10px',
            pointerEvents: this.state.deleting === question.id ? 'none' : null,
            cursor: this.state.deleting ? 'not-allowed' : 'pointer',
          }} onClick={this.handleDelete.bind(this, question.id)}>{
            this.state.deleting === question.id ? this.state.deleteMessage : 'Delete'
          }</button>
          <a target="_blank"
             href={'https://console.firebase.google.com/project/' + DOMAIN + '/database/data/questions/' + question.id}>{question.question}</a>&nbsp;
          <span>{question.quiz}</span>
        </li>
      )
    });

    return (
      <section>
        <h1>All questions</h1>
        <SearchInput
          ref="questionSearch"
          className="search-input"
          onChange={this.searchUpdated.bind(this)}
          placeholder="Search..."
          value={ this.state.searchTerm }
        />
        <ul style={{paddingLeft: '0', marginLeft: '0'}}>
          { questionsList }
        </ul>
      </section>
    );
  }

  componentWillMount() {
    if (this.props.questions) {
      this.updateStateFromProps(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.questions) {
      this.updateStateFromProps(nextProps);
    }
  }

  updateStateFromProps(nextProps) {
    this.setState({
      questions: nextProps.questions
    })
  }

}

Questions.propTypes = {
  questions: PropTypes.array
};

